import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';

export default class LpShowdown extends BaseLP {
    modes = [Const.CAPTAIN_MODE, Const.FLEX_MODE];

    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
    }

    preparePlayerByLPPlayerId({incomingValues: {id}}) {
        return this.exec('preparePlayerByLPPlayerId_ShowDown', {id});
    }

    prepareMaxSection({incomingValues = {}}) {
        return this.exec('prepareMaxSection_ShowDown', incomingValues);
    }

    prepareSectionByTeam({incomingValues = {}}) {
        return this.exec('prepareSectionByTeam_ShowDown', incomingValues);
    }

    prepareSectionByUniquePosition({incomingValues = {}}) {
        return this.exec('prepareSectionByUniquePosition_ShowDown', incomingValues);
    }

    prepareSectionByCaptainPosition({incomingValues = {}}) {
        return this.exec('prepareSectionByCaptainPosition_ShowDown', incomingValues);
    }

    prepareSectionBySalary({incomingValues = {}}) {
        return this.exec('prepareSectionBySalary_ShowDown', incomingValues);
    }

    prepareSectionByPlayer({incomingValues = {}}) {
        return this.exec('prepareSectionByPlayer_ShowDown', incomingValues);
    }

    prepareSectionByCreatedLineups({incomingValues = {}}) {
        return this.exec('prepareSectionByCreatedLineups_ShowDown', incomingValues);
    }

    prepareSectionByExposureMax({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMax_ShowDown', incomingValues, {});
    }

    prepareSectionByExposureMin({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMin_ShowDown', incomingValues);
    }

    prepareSectionByStacks({incomingValues = {}}) {
        return this.exec('prepareSectionByStacks_ShowDown', incomingValues);
    }

    prepareGeneralSection({incomingValues = {}}) {
        return this.exec('prepareGeneralSection_ShowDown', incomingValues);
    }

    prepareBoundSection({incomingValues = {}}) {
        return this.exec('prepareBoundSection_ShowDown', incomingValues);
    }

    prepareMaxRandomSection({incomingValues = {}}) {
        return this.exec('prepareMaxRandomSection_ShowDown', incomingValues);
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {modes: this.modes}, ''),
            teams: this.exec('prepareSectionByTeam', {}, ''),
            captainPositions: this.exec('prepareSectionByCaptainPosition', {}, ''),
            // stacks: this.exec('prepareSectionByStacks', {}, ''),
            keyPlayerStacking: this.exec('keyPlayerStacking', {modes: this.modes}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {modes: this.modes}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            uniquePositions: this.exec('prepareSectionByUniquePosition', {}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            singlegameForcedStacking: this.exec('singlegameForcedStacking', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {modes: this.modes}, ''),
        };

        return {...constraints};
    }
}
